var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext } from "react";
import { createUseStyles } from "react-jss";
import PropTypes from "prop-types";
import { dispatchEvent } from "../../../utils/analytics";
import { GlobalContext } from "../../Context";
var Button = function (_a) {
    var buttonText = _a.buttonText, buttonColor = _a.buttonColor, buttonLink = _a.buttonLink, buttonTarget = _a.buttonTarget, buttonTextColor = _a.buttonTextColor, disableAnalytics = _a.disableAnalytics;
    var useStyles = createUseStyles(function (theme) {
        var _a;
        return ({
            buttonStyling: (_a = {
                    backgroundColor: buttonColor,
                    color: buttonTextColor || "inherit",
                    borderRadius: "55px",
                    width: "100%",
                    padding: "20px 40px",
                    margin: "0 auto",
                    fontSize: "20px",
                    fontWeight: "800",
                    display: "flex",
                    position: "relative",
                    justifyContent: "center",
                    alignItems: "center",
                    textDecoration: "none",
                    height: "75px"
                },
                _a[theme.mediaQuery(theme.breakpoints.medium)] = {
                    width: "auto",
                    fontSize: "25px",
                },
                _a),
        });
    });
    var classes = useStyles();
    var article = useContext(GlobalContext).article;
    return (React.createElement("a", { href: buttonLink, className: classes.buttonStyling, target: buttonTarget || "_self", onClick: function () {
            return !disableAnalytics &&
                dispatchEvent("Button_Clicked", __assign(__assign({}, article), { buttonText: buttonText, buttonLink: buttonLink }));
        } }, buttonText));
};
Button.defaultProps = {
    buttonColor: "#000",
    buttonTextColor: "#FFF",
};
Button.propTypes = {
    buttonText: PropTypes.string.isRequired,
    buttonTextColor: PropTypes.string.isRequired,
    buttonColor: PropTypes.string.isRequired,
    buttonLink: PropTypes.string.isRequired,
    disableAnalytics: PropTypes.bool,
};
export default Button;
